import { spLog } from '@eventr/common'
import {
    ColoursObj,
    ImageRenderer,
    MainButton,
    Typography,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useSignal } from '@preact/signals-react'
import { useEffect } from 'react'
import { Paths } from '../../routes'
import { useThemeContext } from '../../state/themeState/themeContext'
import { logEvent } from '../firebase/firebase'

export const ErrorPage = () => {
    const themeImages = useThemeContext((s) => s.themeImages)

    const taps = useSignal(0)
    function _refreshApp() {
        spLog('Window Reload.')

        window.pushPath(Paths.home)
        window.location.reload()
    }
    const onHiddenClick = () => {
        taps.value = taps.peek() + 1
        if (taps.value === 10) {
            taps.value = 0
            window.pushPath('/devMenu')
        }
    }

    useEffect(() => {
        logEvent('error_page', {})
    }, [])

    return (
        <Stack
            style={{
                height: '100vh',
                background: ColoursObj.backgrounds.primary,
            }}
            className="center"
            justifyContent={'center'}
            alignItems={'center'}
            padding={'16px'}
            gap={'24px'}
        >
            <Typography variant="mobileH3" color={ColoursObj.core.primary}>
                Ooops an error occured !
            </Typography>
            <ImageRenderer variant="error" src={themeImages?.error} />
            <MainButton
                variant="destructiveBorderless"
                size="large"
                text="Click to reload"
                onClick={_refreshApp}
                style={{
                    background: ColoursObj.backgrounds.secondary,
                    width: '100%',
                }}
            />
            {/* <MainButton
                variant="dialogue"
                onClick={() => {
                    fullLogout('/authentication/signin')
                }}
                style={{
                    width: '100%',
                }}
            >
                {i18n.t('account.logout')}
            </MainButton> */}
            <div
                style={{ height: '40px', width: '40px' }}
                onClick={onHiddenClick}
            />
        </Stack>
    )
}
